
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCommandLocked as ObiCommandLockedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-command-locked.js';
 
 
 

 
 export const ObiCommandLocked = createComponent({
   react: React,
   tagName: 'obi-command-locked',
   elementClass: ObiCommandLockedElement,
   events: {
     
   }
  });
 
 